

import { Component, Vue } from "vue-property-decorator"
import { namespace, State } from "vuex-class"

// @ts-ignore

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import ScheduleSetup from "@/components/Config/Schedules/ScheduleSetup.vue"
import { CurrentUser } from "@/types/user"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

const setup = namespace("setup")
const caseStore = namespace("cases")

@Component({
	components: {
		"page": PageWrapper,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"schedule-setup": ScheduleSetup
	}
})
export default class Scheduling extends Vue {
	@State
	me!: CurrentUser | null

	public loading: boolean = true
	public filter: string = ""

	public async mounted () {
		this.loading = false
	}
}

